export default "__VITE_ASSET__C_rmj1vm__"